import React, { useEffect, useState } from 'react';
import CreateRecipeGroup from './blocks/create-recipe-group';
import ConfirmDeleteModal from './blocks/confirm-delete-modal';
import { useDispatch, useSelector } from 'react-redux';
import {
  getRecipeGroups,
  getRecipeGroupsLoading,
  getRecipeGroupsStats,
  removeRecipesGroups
} from './redux/selectors';
import { get_recipe_group, remove_recipe_group } from './redux/reducer';
import LoadingDataUi from '@app/components/loading';
import RecipeGroupTable from './blocks/recipe-group-table';
import { IoSearch } from 'react-icons/io5';
import useDebounce from '@app/Hooks/useDebounce';

const RecipeGroup = () => {
  const [open, setOpen] = useState(false);
  const recipeGroups = useSelector(getRecipeGroups);
  const dispatch = useDispatch();
  const page = 1;
  const pageStats = useSelector(getRecipeGroupsStats);
  const loading = useSelector(getRecipeGroupsLoading);
  const isDeleting = useSelector(removeRecipesGroups);
  const [isFocused, setIsFocused] = useState(false);
  const [search, setSearch] = useState('');
  const debouncedTerm = useDebounce(search, 500);
  const [content, setContent] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  useEffect(() => {
    dispatch(get_recipe_group({ page, limit: 10, search: debouncedTerm }));
  }, [dispatch, page, pageStats, debouncedTerm]);

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleEdit = (doc) => {
    setContent(doc);
    setIsEdit(true);
    setTimeout(() => {
      setOpen(true);
    }, 500);
  };

  const handleDeleteClick = (doc) => {
    setDeleteTarget(doc);
  };

  const handleDeleteConfirm = () => {
    if (deleteTarget) {
      dispatch(remove_recipe_group(deleteTarget._id));
      setDeleteTarget(null);
    }
  };

  return (
    <div>
      <CreateRecipeGroup
        isOpen={open}
        onClose={() => {
          setContent(null);
          setIsEdit(false);
          setOpen(!open);
        }}
        content={content}
        isEdit={isEdit}
      />

      <ConfirmDeleteModal
        isOpen={deleteTarget !== null}
        onClose={() => setDeleteTarget(null)}
        onConfirm={handleDeleteConfirm}
        itemName={deleteTarget?.name}
        isDeleting={isDeleting}
      />

      <div className="flex justify-between items-center px-5 my-6">
        <div
          className={`flex items-center duration-700 ease-in-out ${
            isFocused
              ? 'border border-[#003333] border-opacity-50 shadow-[#003333] ring ring-[#ACD1D1] ring-opacity-30'
              : 'border border-[#E0E0E0] '
          } rounded-[10px] w-[400px] px-3`}
        >
          <IoSearch size={20} color="#64748B" />
          <input
            type="text"
            placeholder="Search recipe group"
            onBlur={handleBlur}
            onFocus={handleFocus}
            onChange={(e) => setSearch(e.target.value)}
            className="p-3 w-full bg-transparent focus:border-0 focus:outline-none"
          />
        </div>

        <button
          onClick={() => setOpen(true)}
          className="h-[51px] bg-[#549A9A] text-white font-semibold text-[15px] rounded-[5px] w-[200px]"
        >
          Add new
        </button>
      </div>

      <div>
        {loading ? (
          <LoadingDataUi />
        ) : (
          <div className="px-5">
            <RecipeGroupTable
              group={recipeGroups}
              handleEdit={handleEdit}
              onDeleteClick={handleDeleteClick}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RecipeGroup;
